import { isIPad } from './commonUtil';
import { FILE_CODE } from './constants';
import StaticFileService from '../services/StaticFiles';
import _ from 'lodash';

const printBlob = (blob, fileName, fileCode = FILE_CODE.EXCEL) => {
  if (isIPad() && fileCode === FILE_CODE.PDF) {
    return;
  }
  if (window.navigator.msSaveBlob) {
    return window.navigator.msSaveOrOpenBlob(blob, fileName);
  }

  const reader = new FileReader();
  reader.onload = () => {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = reader.result;
    link.click();
    return;
  };
  reader.readAsDataURL(blob);
};

const printOrOpenBlob = async (
  getBlob,
  fileName,
  fileCode = FILE_CODE.EXCEL,
  isReportMessage = true
) => {
  // iPadの場合は直接ダウンロードして表示できないので別タブで表示する
  if (isIPad()) {
    // 非同期メソッド完了後にwindow.openするとポップアップブロックの対象になるため先にopenしておく
    let newTab = isReportMessage
      ? window.open('/LayoutPrint', '_blank')
      : window.open('/FileOutput', '_blank');
    const blob = await getBlob();
    if (!blob) {
      newTab.close();
      newTab = null;
      return;
    }
    const url = URL.createObjectURL(blob);
    newTab.location = url;
    newTab = null;
    setTimeout(function() {
      URL.revokeObjectURL(url);
    }, 10000);
  } else {
    const blob = await getBlob();
    if (!blob) {
      return;
    }
    printBlob(blob, fileName, fileCode);
  }
};

const convertBase64ToBlob = (base64Data, contentType) => {
  const bin = atob(base64Data.replace(/\s/g, ''));
  const arrBuffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    arrBuffer[i] = bin.charCodeAt(i);
  }
  return new Blob([arrBuffer.buffer], { type: contentType });
};

const downloadStaticFilePDF = async (fileCode, fileName, showErrorFunc) => {
  const params = { file_code: fileCode };
  await printOrOpenBlob(
    () => {
      return StaticFileService.files(params).then(response => {
        if (_.includes(response.type, 'octet-stream')) {
          const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
          return new Blob([bom, response], { type: 'application/pdf' });
        } else {
          if (_.isFunction(showErrorFunc)) {
            showErrorFunc(true);
          }
          return null;
        }
      });
    },
    fileName,
    FILE_CODE.PDF,
    false
  );
};

const downloadFilePresignedUrl = (presignedUrl, fileName) => {
  return fetch(presignedUrl).then(response => {
    response.blob().then(blob => {
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    });
  });
};

const PrintUtility = {
  printBlob,
  convertBase64ToBlob,
  printOrOpenBlob,
  downloadStaticFilePDF,
  downloadFilePresignedUrl,
};

export default PrintUtility;



// WEBPACK FOOTER //
// ./src/utilities/printUtility.js